import PropTypes from 'prop-types';

import classes from './GraduationProfile.module.css';

const GraduationProfile = ({ productData }) => {
  return (
    <div className={classes.section}>
      <p className={classes.sectionTitle}>Perfil de egreso</p>
      <p>{productData.graduationProfile[0].description}</p>
      {productData.graduationProfile[0].info && (
        <ul className={classes.profileContainer}>
          {productData.graduationProfile[0].info.map(info => (
            <li
              key={info.text}
              className={
                info.icon
                  ? classes.profileItemE
                  : classes.profileItemENI
              }
            >
              {info.icon && (
                <figure className={classes.profileIcon}>
                  <img
                    className={classes.img}
                    src={info.icon}
                    alt={info.text}
                  />
                </figure>
              )}
              {info.descriptionInfo && <p>{info.descriptionInfo}</p>}
              <span
                className={
                  info.icon
                    ? classes.profileDescriptionE
                    : classes.profileDescriptionENI
                }
              >
                {info.text}
              </span>
            </li>
          ))}
        </ul>
      )}
      {productData.graduationProfile[0].itemsInfo &&
        productData.graduationProfile[0].itemsInfo.map(item => (
          <div
            key={item.descriptionInfo}
            className={classes.itemContainer}
          >
            <p>{item.descriptionInfo}</p>
            <ul>
              {item.items.map(item => (
                <li key={item} className={classes.item}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
};

GraduationProfile.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default GraduationProfile;
